import ReactDOM from 'react-dom/client';

import ApplicationRoot from './ApplicationRoot';
import './index.css';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<ApplicationRoot />);
